export default Object.freeze({
  Operator: 1,
  Distributor: 2,
  Partner: 3,
  Reseller: 4,
  ReferralAgent: 5,
});
